import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AuditTableService } from './audit-table.service';

@Component({
    selector: 'app-audit-table',
    templateUrl: './audit-table.component.html',
    styleUrls: ['./audit-table.component.scss'],
    standalone: false
})
export class AuditTableComponent implements OnInit, OnChanges {
  @Input() tableName!: string;
  @Input() recordId!: number;
  @Input() fieldName!: string;

  auditData: any[] = [];
  loading = false;

  constructor(private auditTableService: AuditTableService) {}

  ngOnInit(): void {
    this.fetchAuditData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableName'] || changes['recordId'] || changes['fieldName']) {
      this.fetchAuditData();
    }
  }

  fetchAuditData() {
    if (!this.tableName || !this.recordId || !this.fieldName) return;
    this.loading = true;
    this.auditTableService.getAuditData(this.tableName, this.recordId, this.fieldName)
      .subscribe({
        next: (res: any) => {
          this.auditData = res.data || [];
          this.loading = false;
        },
        error: () => {
          this.auditData = [];
          this.loading = false;
        }
      });
  }
}